<mat-form-field
  class="balance-charges-appointment-picker"
  data-balance-charges-appointment-picker
  subscriptSizing="dynamic">
  <mat-label>{{ 'balance.charges.appointments' | translate }}</mat-label>
  <mat-select
    multiple
    [formControl]="control"
    [panelClass]="cocMode ? 'balance-charges-appointment-picker__panel' : 'balance-charges-appointment-picker__panel balance-charges-appointment-picker__panel--single'"
    (selectionChange)="onChange($event.value)">
    <mat-option
      *ngIf="!readOnly"
      class="balance-charges-appointment-picker__coc-toggle-option"
      data-balance-charges-coc-toggle
      [value]="COC_TOGGLE_OPTION_VALUE"
      [disabled]="isCocToggleDisabled()"
      [matTooltip]="isCocToggleDisabled() ? ('balance.charges.unscheduled-mode-locked-tooltip' | translate) : ''"
      (onSelectionChange)="$event.isUserInput && onCocToggle()">
      <mat-slide-toggle
        [checked]="cocMode"
        [disabled]="isCocToggleDisabled()"
        (click)="$event.preventDefault(); $event.stopPropagation(); onCocToggle()">
        {{ 'balance.charges.coc-toggle-label' | translate }}
      </mat-slide-toggle>
    </mat-option>
    <mat-option
      *ngIf="cocMode && !readOnly"
      class="balance-charges-appointment-picker__unscheduled-option"
      data-balance-charges-unscheduled-option
      [value]="UNSCHEDULED_OPTION_VALUE"
      [disabled]="isUnscheduledDisabled()"
      [matTooltip]="unscheduledTooltipKey() | translate">
      {{ 'balance.charges.unscheduled-option' | translate }}
    </mat-option>
    <mat-option
      *ngFor="let option of options(); trackBy: trackByValue"
      [value]="option.value"
      [disabled]="option.disabled || (cocMode && isScheduledOptionDisabled(option.value))"
      [matTooltip]="(cocMode && !option.disabled && isScheduledOptionDisabled(option.value)) ? ('balance.charges.unscheduled-exclusivity-tooltip' | translate) : ''"
      [attr.data-appointment-id]="option.value">
      <span *ngIf="option.appointment?.startAt; else order">{{ option.appointment.startAt | momentDateTime }}</span>
      <ng-template #order>
        <span>{{ 'balance.charges.appointment-order' | translate }}</span>
      </ng-template>
      <ng-container *ngIf="option.hint; else noProcedureCodes"> ({{ option.hint }})</ng-container>
      <ng-template #noProcedureCodes>
        <span class="text-warn ml-2">({{ 'balance.charges.appointment-no-cpt-codes' | translate }})</span>
      </ng-template>
      <span *ngIf="option.hasEstimate" class="text-warn">
        - {{ 'balance.charges.appointment-already-used' | translate }}
      </span>
      <span *ngIf="option.visitNumber">
        - {{ 'balance.charges.visit-number' | translate:{ number: option.visitNumber } }}
      </span>
    </mat-option>
  </mat-select>
</mat-form-field>
